import { Image, View, ViewProps } from 'react-native';
import { InlineAlert } from 'ucl/components/inline-alert';

import { primitive } from 'styles/constants/primitives';

const MASTERCARD_IMAGE_WIDTH = 24;
const MASTERCARD_IMAGE_HEIGHT = 12;
const MASTERCARD_IMAGE_URL = `https://cdn.sanity.io/images/kjfd81ul/prod_bk_us/fa32d487a257d85d5ae000ba77bfef96f89cbec3-192x192.png?w=${MASTERCARD_IMAGE_WIDTH}&h=${MASTERCARD_IMAGE_HEIGHT}&fit=crop`;

const MasterCardLogo = () => (
  <Image
    style={{ width: MASTERCARD_IMAGE_WIDTH, height: MASTERCARD_IMAGE_HEIGHT }}
    source={{
      uri: MASTERCARD_IMAGE_URL,
    }}
  />
);

export const MastercardPartnershipAlert = ({
  style,
  short,
}: {
  style?: ViewProps['style'];
  short?: boolean;
}) => {
  return (
    <View style={style}>
      <InlineAlert
        message={
          short ? (
            <>
              Add a Mastercard® <MasterCardLogo /> to get a FREE Whopper Jr.®!
            </>
          ) : (
            <>
              Pay with your Mastercard® <MasterCardLogo /> to unlock a FREE Whopper Jr.® with your
              next $3 purchase
            </>
          )
        }
        status="warning"
        bgColor={primitive.bk.$meltyYellowOpacity20}
        size="sm"
      />
    </View>
  );
};
